import React, { useState, useEffect } from 'react';
import { Search, User, Bell } from 'lucide-react';
import AddCustomerForm from './AddCustomerForm';
import { useSelector } from 'react-redux';

const ManageCustomersPage = () => {
  const token = useSelector((state) => state.auth.token);
  const [searchTerm, setSearchTerm] = useState('');
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [showAddCustomerForm, setShowAddCustomerForm] = useState(false);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_SERVICE_API_URL}/service/customers?providerId=${user.id}&page=1&limit=10`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Api-Name': 'service-api',
          }
        });
        const response_json = await response.json();
        setCustomers(response_json.customers)
        console.log(response_json.customers)
      } catch (error) {
        console.error('Error fetching customers:', error);
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    setFilteredCustomers(
      customers.filter(customer =>
        customer.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, customers]);

  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="flex justify-between items-center mb-4 gap-8">
        <div className="relative flex-grow">
          <input
            type="text"
            placeholder="Search..."
            className="w-full pl-10 pr-4 py-2 border rounded-full h-12"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
        <div onClick={() => setShowAddCustomerForm(true)} className="p-4 flex w-full items-center justify-center space-x-6 p-6 rounded-full bg-sec-dark shadow-md shadow-pri-dark-shadow w-6 h-6 lg:max-w-6 lg:max-h-6 active:translate-y-1 active:shadow-none">
          <p className="text-4xl text-pri-white">+</p>
        </div>
      </div>
      
      <div className="space-y-2 text-pri-white">
        {filteredCustomers.map(customer => (
          <a key={customer.id} href={`/customer/${customer.id}`}>
            {customer.name}
          </a>
        ))}
      </div>
    </div>
  );
};

export default ManageCustomersPage;